var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper border border-light"},[_c('p',[_vm._v(_vm._s(_vm.err))]),_vm._v(" "),_c('vue-rvc-login',{attrs:{"api-endpoint":"api/auth.cfc","app-name":"Room Schedule"},on:{"success":_vm.success,"fail":_vm.clear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }